//@flow
import React, { Component } from 'react';
import { PaginatorWrapper, PageNumberH4, ChevronSvg } from './PaginatorStyles';
import { Mobile, Default } from './Responsive';

export type PaginatorProps = {
  paginatorTotal: number,
  currentPage: number,
  changePage: (value: number) => void,
  previouslyVisited: Array<number>
};

class Paginator extends Component<PaginatorProps> {
  changePage = (pageNumber: number) => {
    this.props.changePage(pageNumber);
  };

  calculatePreviouslyVisited = (i: number) => {
    if (this.props.previouslyVisited.includes(i + 1)) {
      return true;
    }
    return false;
  };

  renderPageNumber = (i: number) => {
    if (this.props.paginatorTotal > 7) {
      if (this.props.currentPage < 7) {
        return this.earlyPagination(i);
      } else if (
        this.props.currentPage >= 7 &&
        this.props.currentPage <= this.props.paginatorTotal - 6
      ) {
        return this.middlePagination(i);
      } else {
        return this.latePagination(i);
      }
    } else {
      return this.regularPagination(i);
    }
  };

  regularPagination = (i: number) => (
    <PageNumberH4
      previouslyVisited={this.calculatePreviouslyVisited(i)}
      currentPage={this.props.currentPage === i + 1}
      onClick={() => this.props.changePage(i + 1)}
    >
      {i + 1}
    </PageNumberH4>
  );

  earlyPagination = (i: number) => (
    <>
      {i < 7 && this.pageNumber(i, i + 1)}
      {i === this.props.paginatorTotal - 1 && (
        <PageNumberH4 paginatorBreak>...</PageNumberH4>
      )}
      {i === this.props.paginatorTotal - 1 &&
        this.pageNumber(
          i,
          i === this.props.paginatorTotal - 1 && this.props.paginatorTotal
        )}
    </>
  );

  middlePagination = (i: number) => (
    <>
      {i === 0 && this.pageNumber(i, 1)}
      {i === 0 && <PageNumberH4 paginatorBreak>...</PageNumberH4>}
      <Default>
        {i > this.props.currentPage - 5 &&
          i < this.props.currentPage + 3 &&
          this.pageNumber(i, i + 1)}
      </Default>
      <Mobile>
        {i > this.props.currentPage - 3 &&
          i < this.props.currentPage + 1 &&
          this.pageNumber(i, i + 1)}
      </Mobile>
      {i === this.props.paginatorTotal - 1 && (
        <PageNumberH4 paginatorBreak>...</PageNumberH4>
      )}
      {i === this.props.paginatorTotal - 1 &&
        this.pageNumber(i, this.props.paginatorTotal)}
    </>
  );

  latePagination = (i: number) => (
    <>
      {i === 0 && this.pageNumber(i, 1)}
      {i === 0 && <PageNumberH4 paginatorBreak>...</PageNumberH4>}
      {i >= this.props.paginatorTotal - 7 && this.pageNumber(i, i + 1)}
    </>
  );

  pageNumber = (i: number, pages: number | boolean) => (
    <PageNumberH4
      previouslyVisited={this.calculatePreviouslyVisited(i)}
      currentPage={this.props.currentPage === i + 1}
      onClick={() => this.props.changePage(i + 1)}
    >
      {pages}
    </PageNumberH4>
  );

  render() {
    const calculateBack =
      this.props.currentPage === 1 ? 1 : this.props.currentPage - 1;
    const calculateForward =
      this.props.currentPage === this.props.paginatorTotal
        ? this.props.paginatorTotal
        : this.props.currentPage + 1;
    return (
      <PaginatorWrapper>
        {[...Array(this.props.paginatorTotal)].map((_, i) => (
          <React.Fragment key={i}>
            {i === 0 && (
              <ChevronSvg
                styled={{ chevronLeft: true }}
                onClick={() => this.props.changePage(calculateBack)}
              />
            )}
            {this.renderPageNumber(i)}
            {i === this.props.paginatorTotal - 1 && (
              <ChevronSvg
                styled={{ chevronRight: true }}
                onClick={() => this.props.changePage(calculateForward)}
              />
            )}
          </React.Fragment>
        ))}
      </PaginatorWrapper>
    );
  }
}

export default Paginator;
